import { CheckCircle2, XCircle, MessageSquare } from "lucide-react";

const Explain = ({ text, testid }) => (
  <details className="mt-1.5 group" data-testid={testid}>
    <summary className="text-xs font-semibold text-emerald-300 cursor-pointer select-none">Show explanation</summary>
    <div className="mt-1.5 text-xs text-slate-300 leading-relaxed whitespace-pre-wrap bg-[#0E1420] border-l-2 border-emerald-500 rounded-r-lg px-3 py-2">{text}</div>
  </details>
);

export default function SubmissionDetail({ submission }) {
  const detail = submission?.detail || [];
  if (submission?.type === "vision_handwritten") {
    return (
      <div className="space-y-2">
        <div className="text-sm text-slate-300">{submission.ai_feedback}</div>
        {submission.extracted_text && (
          <details>
            <summary className="text-xs text-slate-500 cursor-pointer">View extracted text</summary>
            <p className="text-xs text-slate-500 mt-1 whitespace-pre-wrap">{submission.extracted_text}</p>
          </details>
        )}
      </div>
    );
  }
  return (
    <div className="space-y-2.5">
      {detail.map((d, i) => (
        <div key={i} className="p-3 rounded-xl bg-[#090D16] border border-[#1E293B]">
          <div className="flex items-center justify-between mb-1">
            <span className={`text-[10px] uppercase tracking-wider font-semibold px-1.5 py-0.5 rounded ${d.type === "mcq" ? "bg-indigo-500/15 text-indigo-400" : "bg-amber-500/15 text-amber-400"}`}>
              {d.type === "mcq" ? "MCQ" : "Written"}
            </span>
            <span className="text-xs font-semibold text-emerald-400">{d.awarded}/{d.points} pts</span>
          </div>
          <div className="text-sm font-medium text-slate-100">Q{i + 1}. {d.question}</div>
          {d.type === "mcq" ? (
            <div className="mt-1.5 text-sm space-y-0.5">
              <div className={`flex items-center gap-1.5 ${d.is_correct ? "text-emerald-400" : "text-rose-400"}`}>
                {d.is_correct ? <CheckCircle2 className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />}
                Answer: {d.chosen >= 0 && d.chosen < d.options.length ? d.options[d.chosen] : "Not answered"}
              </div>
              {!d.is_correct && <div className="text-emerald-400 text-sm pl-5">Correct: {d.options[d.correct_index]}</div>}
              {d.solution && <Explain text={d.solution} testid={`explain-${i}`} />}
            </div>
          ) : (
            <div className="mt-1.5 text-sm space-y-1">
              <div className="text-slate-300"><span className="text-slate-500">Answer:</span> {d.student_answer || "—"}</div>
              {d.feedback && <div className="text-amber-300/90 flex items-start gap-1.5"><MessageSquare className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {d.feedback}</div>}
              {d.model_answer && <Explain text={d.model_answer} testid={`explain-${i}`} />}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
